import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';

class MapChart extends React.Component {
  componentDidMount() {
    const mapParams = this.props.mapParams ? this.props.mapParams : {
      map: this.props.map,
      backgroundColor: this.props.backgroundColor,
      zoomOnScroll: this.props.zoomOnScroll,
      zoomOnScrollSpeed: this.props.zoomOnScrollSpeed,
      panOnDrag: this.props.panOnDrag,
      zoomMax: this.props.zoomMax,
      zoomMin: this.props.zoomMin,
      zoomStep: this.props.zoomStep,
      zoomAnimate: this.props.zoomAnimate,
      regionsSelectable: this.props.regionsSelectable,
      regionsSelectableOne: this.props.regionsSelectableOne,
      markersSelectable: this.props.markersSelectable,
      markersSelectableOne: this.props.markersSelectableOne,
      regionStyle: this.props.regionStyle,
      regionLabelStyle: this.props.regionLabelStyle,
      markerStyle: this.props.markerStyle,
      markerLabelStyle: this.props.markerLabelStyle,
      markers: this.props.markers,
      series: this.props.series,
      onRegionLabelShow: this.props.onRegionLabelShow,
      focusOn: this.props.focusOn,
      labels: this.props.labels,
      selectedRegions: this.props.selectedRegions,
      selectedMarkers: this.props.selectedMarkers,
      onRegionTipShow: this.props.onRegionTipShow,
      onRegionOver: this.props.onRegionOver,
      onRegionOut: this.props.onRegionOut,
      onRegionClick: this.props.onRegionClick,
      onRegionSelected: this.props.onRegionSelected,
      onMarkerTipShow: this.props.onMarkerTipShow,
      onMarkerOver: this.props.onMarkerOver,
      onMarkerOut: this.props.onMarkerOut,
      onMarkerClick: this.props.onMarkerClick,
      onMarkerSelected: this.props.onMarkerSelected,
      onViewportChange: this.props.onViewportChange
    };
    $(`#${this.props.id}`).vectorMap(mapParams);
  }
  render() {
    return (
      <div
        id={this.props.id}
        style={{
          width: this.props.width,
          height: this.props.height
        }}
      />
    );
  }
};
MapChart.propTypes = {
  id: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  mapParams: PropTypes.object,
  map: PropTypes.string,
  backgroundColor: PropTypes.string,
  zoomOnScroll: PropTypes.bool,
  zoomOnScrollSpeed: PropTypes.number,
  panOnDrag: PropTypes.bool,
  zoomMax: PropTypes.number,
  zoomMin: PropTypes.number,
  zoomStep: PropTypes.number,
  zoomAnimate: PropTypes.bool,
  regionsSelectable: PropTypes.bool,
  regionsSelectableOne: PropTypes.bool,
  markersSelectable: PropTypes.bool,
  markersSelectableOne: PropTypes.bool,
  regionStyle: PropTypes.object,
  regionLabelStyle: PropTypes.object,
  markerStyle: PropTypes.object,
  markerLabelStyle: PropTypes.object,
  markers: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  series: PropTypes.object,
  focusOn: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  labels: PropTypes.object,
  selectedRegions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string
  ]),
  selectedMarkers: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string
  ]),
  onRegionTipShow: PropTypes.func,
  onRegionOver: PropTypes.func,
  onRegionOut: PropTypes.func,
  onRegionClick: PropTypes.func,
  onRegionSelected: PropTypes.func,
  onMarkerTipShow: PropTypes.func,
  onMarkerOver: PropTypes.func,
  onMarkerOut: PropTypes.func,
  onMarkerClick: PropTypes.func,
  onMarkerSelected: PropTypes.func,
  onViewportChange: PropTypes.func
};
MapChart.defaultProps = {
  id: 'world-map-0',
  width: "100%",
  height: "300px",
  map: 'world_mill_en',
  backgroundColor: "#555555",
  zoomOnScroll: true,
  zoomOnScrollSpeed: 3,
  panOnDrag: true,
  zoomMax: 8,
  zoomMin: 1,
  zoomStep: 1.6,
  regionsSelectable: false,
  regionsSelectableOne: false,
  markersSelectable: false,
  markersSelectableOne: false,
  regionStyle: {
    initial: {
      fill: '#bbbbbb',
      "fill-opacity": 1,
      stroke: 'none',
      "stroke-width": 0,
      "stroke-opacity": 1
    },
    hover: {
      "fill-opacity": 0.8,
      cursor: 'pointer'
    },
    selected: {
      fill: 'yellow'
    },
    selectedHover: {
    }
  },
  regionLabelStyle: {
    initial: {
      'font-family': 'Verdana',
      'font-size': '12',
      'font-weight': 'bold',
      cursor: 'default',
      fill: 'black'
    },
    hover: {
      cursor: 'pointer'
    }
  },
  markerStyle: {
    initial: {
      fill: 'grey',
      stroke: '#505050',
      "fill-opacity": 1,
      "stroke-width": 1,
      "stroke-opacity": 1,
      r: 5
    },
    hover: {
      stroke: 'black',
      "stroke-width": 2,
      cursor: 'pointer'
    },
    selected: {
      fill: 'blue'
    },
    selectedHover: {
    }
  },
  markerLabelStyle: {
    initial: {
      'font-family': 'Verdana',
      'font-size': '12',
      'font-weight': 'bold',
      cursor: 'default',
      fill: 'black'
    },
    hover: {
      cursor: 'pointer'
    }
  }
};

export default MapChart;
